import { useTheme } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

export const AuthorizeFallback = ({ message }: { message?: string }) => {
    const theme = useTheme();
    return (
        <Alert severity="error" style={{ margin: theme.spacing(1) }}>
            {message || "You're not authorized!"}
        </Alert>
    );
};
